import { render, staticRenderFns } from "./DocumentConfirmModal.vue?vue&type=template&id=01301d84&scoped=true&"
import script from "./DocumentConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DocumentConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentConfirmModal.vue?vue&type=style&index=0&id=01301d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01301d84",
  null
  
)

export default component.exports